namespace Ir.Components.Filters.FilterList {
    interface IViewModel {
        filters: KnockoutObservableArray<Filter>;
        sortableConfig: DevExpress.ui.dxSortable.Properties;      
        isToolbar: KnockoutObservable<boolean>;
        isDrilldown: KnockoutObservable<boolean>;
    }

    interface IParams {
        filters: KnockoutObservableArray<Filter>;
        config: IFilterListParams;
    }

    export interface IFilterListParams {        
        orientation: string;
        isToolbar?: KnockoutObservable<boolean>;
        isDrilldown?: KnockoutObservable<boolean>;

        onOrderChanged?: (filters: KnockoutObservableArray<Filter>) => void;
    }

    export function getViewModel(this: IViewModel, params: IParams) {
        let self = this;
        this.filters = params.filters;
        this.isToolbar = params.config.isToolbar;
        this.isDrilldown = params.config.isDrilldown;

        this.sortableConfig = {
            allowReordering: this.isDrilldown ? false : true,
            data: { fields: this.filters },
            filter: '.filter-list-item',
            dragDirection: params.config.orientation as any ?? "vertical",
            itemOrientation: params.config.orientation as any ?? "vertical",
            moveItemOnDrop: false,
            onReorder(e) {
                if (e.toIndex >= 0 && self.filters().length > 1) {
                    let fromField = self.filters.splice(e.fromIndex, 1)[0];
                    self.filters.splice(e.toIndex, 0, fromField);

                    if (params.config.onOrderChanged) {
                        params.config.onOrderChanged(self.filters);
                    }
                }
            }
        };
    }
}